module.exports = __webpack_public_path__ + "static/media/hindsight_students.44fa72a8.png";